import React from 'react';
import icon_person from '../src/imgs/person_icon.svg';
import icon_teacher from '../src/imgs/teacher_icon.svg';
import icon_calendar from '../src/imgs/calendar_icon.svg';
import icon_location from '../src/imgs/pinpoint_icon.svg';


import { Link } from 'react-router-dom';
import { useStore } from '../../../app/stores/store';
import { calculoFechas } from '../helpers/calculoFechas';
import { nombreDelegacion } from '../helpers/nombreDelegacion';

export const CursosGridItem = ({ imagen, nombre, modalidad, id, edicion, fechaInicio, estudiantes, catedratico, certificacion }) => {
    
    const { userStore: { user } } = useStore();
    const url = `/asesoria/${ encodeURI( id ) }/${user?.id}`;

    return (
        
        <div className="portafolio_card">
                <Link to={ url }>

                    <div className="pcard_imagen"> <img src={ imagen } alt={ nombre } /></div>

                    <div className="pcard_tipoc">
                        <p>{ modalidad }</p>
                    </div>

                    <div className="pcard_contenido_publico">

                        <div className="pcard_edicion">
                            <p>-Edición en curso { edicion }</p>
                        </div>

                        <div className="pcard_titulo_curso">
                            <p className='titulo_curso' id='titulo_curso'>{ nombre }</p>
                        </div>

                        <div className="card_info_curso">
                            <div className="pcard_estudiantes">
                                <img src={ icon_person } />
                                <p>Inicio de inscripciones</p>
                            </div>
                            <div className="pcard_fecha">
                                <img src={ icon_calendar } />
                                <p>{ calculoFechas( fechaInicio ) }</p>
                            </div>
                        </div>
                                            
                        <div className="pcard_docentes">
                        <img src={icon_location} />
                          <p>Sede: {nombreDelegacion(certificacion)}</p>
                        </div>

                    </div>

                    <div className="pcard_linea"><span></span></div>

                </Link>
            </div>       
    )
}